module.exports = __webpack_public_path__ + "static/media/digit.99b2490c.png";